import React from 'react';
import { useIntl } from 'react-intl';
import groupBy from 'lodash/groupBy';
import useDetailsContext from '../context';
import $ from '~/helpers/$';
function Authors({ heading, className, authors = [] }) {
    if (authors.length === 0) {
        return null;
    }
    return (React.createElement("div", null,
        React.createElement("h3", { className: "author-heading" }, heading),
        authors.map((author) => (React.createElement("div", { className: className, key: author.name },
            author.name,
            author.university ? `, ${author.university}` : '')))));
}
export default function AuthorsSection() {
    const { authors, title } = useDetailsContext();
    const polish = $.isPolish(title);
    const intl = useIntl();
    const headings = polish
        ? ['Główni autorzy', 'Autorzy współpracujący']
        : [
            intl.formatMessage({ id: 'authors.senior' }),
            intl.formatMessage({ id: 'authors.contributing' })
        ];
    const groupFn = (author) => author.seniorAuthor ? 'senior' : 'regular';
    const groupedAuthors = groupBy(authors, groupFn);
    return (React.createElement(React.Fragment, null,
        React.createElement(Authors, { heading: headings[0], className: "loc-senior-author", authors: groupedAuthors.senior }),
        React.createElement(Authors, { heading: headings[1], className: "loc-nonsenior-author", authors: groupedAuthors.regular })));
}
